<template>
  <div id="app" :class="{ fullscreen: isFullScreen }" :style="{ 'padding-top': hasHeader ? '46px' : '' }">
    <van-nav-bar fixed :left-arrow="!noBackBtn" @click-left="onClickLeft" v-if="hasHeader" />
    <!-- <keep-alive include="buyDetail"> -->
    <router-view class="app-view" />
    <!-- </keep-alive> -->
    <van-tabbar active-color="#b80f0d" v-model="tabbaractive" v-if="hasTabbar">
      <van-tabbar-item to="/index" name="index">首页
        <template #icon="props">
          <img :src="props.active ? icon.index.active : icon.index.inactive" />
        </template>
      </van-tabbar-item>
      <van-tabbar-item to="/order" name="order">订单
        <template #icon="props">
          <img :src="props.active ? icon.order.active : icon.order.inactive" />
        </template>
      </van-tabbar-item>
      <van-tabbar-item to="profile" name="profile">我的
        <template #icon="props">
          <img :src="props.active ? icon.profile.active : icon.profile.inactive" /> </template></van-tabbar-item>
      <van-tabbar-item to="call" name="call">客服
        <template #icon="props">
          <img :src="props.active ? icon.call.active : icon.call.inactive" />
        </template>
      </van-tabbar-item>
    </van-tabbar>
  </div>
</template>

<script>
import "@/util/COVERAPP"
import { mapGetters } from "vuex"
export default {
  name: "App",
  data() {
    return {
      log: '',
      tabbaractive: "index",
      icon: {
        index: {
          active: require("./assets/img/icon/home1.png"),
          inactive: require("./assets/img/icon/home.png"),
        },
        order: {
          active: require("./assets/img/icon/order1.png"),
          inactive: require("./assets/img/icon/order.png"),
        },
        profile: {
          active: require("./assets/img/icon/profile1.png"),
          inactive: require("./assets/img/icon/profile.png"),
        },
        call: {
          active: require("./assets/img/icon/call1.png"),
          inactive: require("./assets/img/icon/call.png"),
        },
      },
    }
  },
  computed: {
    ...mapGetters(["userInfo"]),
    hasHeader() {
      return this.$route.meta.hasHeader
    },
    hasTabbar() {
      return this.$route.meta.hasTabbar
    },
    isFullScreen() {
      return this.$route.meta.isFullScreen
    },
    noBackBtn() {
      return this.$route.meta.noBackBtn
    },
    isApp() {
      return window.COVERAPP.Attribute.isApp()
    }
  },
  created() {
    // this.getArea();
    this.listenResize()
    window.addEventListener("resize", this.listenResize, false)

  },
  watch: {
    $route: {
      immediate: true,
      handler() {
        this.tabbaractive = this.$route.name
      },
    },
  },
  methods: {
    // getArea() {
    //   const treeData = sessionStorage.getItem("treeData")
    //   !treeData &&
    //     this.$http.getGeoDivisionTree({}).then((res) => {
    //       // let pinitCode = 10
    //       // let cinitCode = 10
    //       // let coinitCode = 10
    //       // let codeMapId = {}
    //       // let province_list = {}
    //       // let city_list = {}
    //       // let county_list = {}

    //       // res.data.forEach((p) => {
    //       //   p.code = `${++pinitCode}0000`
    //       //   province_list[p.code] = p.areaname
    //       //   codeMapId[p.code] = p.areaId
    //       //   if (Array.isArray(p.children)) {
    //       //     p.children.forEach((c) => {
    //       //       c.code = `${pinitCode}${++cinitCode}00`
    //       //       city_list[c.code] = c.areaname
    //       //       codeMapId[c.code] = c.areaId
    //       //       if (Array.isArray(c.children)) {
    //       //         c.children.forEach((co) => {
    //       //           co.code = `${pinitCode}${cinitCode}${++coinitCode}`
    //       //           county_list[co.code] = co.areaname
    //       //           codeMapId[co.code] = co.areaId
    //       //         })
    //       //       }
    //       //     })
    //       //   }
    //       // })
    //       sessionStorage.setItem(
    //         "treeData",
    //         JSON.stringify({
    //           // pickerList: {
    //           //   province_list,
    //           //   city_list,
    //           //   county_list,
    //           // },
    //           // codeMapId,
    //           tree: res.data,
    //         })
    //       )
    //     })
    // },
    handlerRight() {
      if (this.$route.meta.rightTo) {
        this.$router.push(this.$route.meta.rightTo)
      }
      if (this.$route.meta.rightEvent) {
        this.$store.dispatch(this.$route.meta.rightEvent)
      }
    },
    onClickLeft() {
      if (this.$route.meta.rightTo) {
        this.$router.push(this.$route.meta.rightTo)
      } else {
        this.$router.back()
      }
    },
    //定义一个函数判断是手机端还是pc端
    isMobile() {
      return window.navigator.userAgent.match(
        /(phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i
      )
    },

    listenResize() {
      //    判断后的操作
      if (this.isMobile()) {
        document.documentElement.style = `font-size:${(document.documentElement
          .clientWidth /
          750) *
          100}px;`
      } else {
        document.documentElement.style = `font-size:${(450 / 750) *
          100}px;max-width:450px;margin:0 auto;`
      }
    },
  },
}
</script>

<style lang="scss">
html,
body {
  height: 100%;
  background-color: #f7f8fa;
}

/* .paddingTop {
  padding-top: 46px !important;
}
.paddingTop2 {
  padding-top: 60px !important;
} */
#app {
  box-sizing: border-box;
  font-family: "Avenir", Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  color: #2c3e50;

  /* background-color: #fff; */
  .van-nav-bar .van-icon {
    font-size: 0.3rem;
    color: #333;
  }
}
</style>



// WEBPACK FOOTER //
// src/App.vue